import GameRedux from './game_redux';

GameRedux.displayName = 'GameRedux';

export default GameRedux;
